// extracted by mini-css-extract-plugin
export default {"root":"PersonalAccountSelect_root__y0nt1","tab":"PersonalAccountSelect_tab__tRFG0","isSelected":"PersonalAccountSelect_isSelected__zj35w"};